import * as React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Theme,
  createStyles,
  makeStyles,
} from '@bb-ui/react-library';
import { useTranslation } from 'react-i18next';

export interface TenantInformationItemProps {
  title: string;
  value?: string;
  href?: string;
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      border: 'none',
      display: 'grid',
      gridSpacing: theme.spacing(2),
      gridTemplateColumns: '1fr 1fr',
      marginBottom: '1px',
    },
    cardContent: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.fontSizeSmall,
      textAlign: 'right',
    },
    cardHeader: {
      fontSize: theme.typography.fontSizeSmall,
      fontWeight: theme.typography.fontWeightBold,
    },
    unsetValue: {
      fontStyle: 'italic',
    },
    tenantLink: {
      color: theme.palette.text.secondary,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }),
);

export const TenantInformationItem: React.FC<TenantInformationItemProps> = (props) => {
  const { title, value, href } = props;
  const classes = useStyles(props);
  const { t } = useTranslation();

  const renderValue = () => {
    if (value == null) {
      return <span className={classes.unsetValue}>{t('tenantInformation.unset')}</span>;
    }
    if (href) {
      return (
        <a href={href} target="_blank" rel="noopener noreferrer" className={classes.tenantLink}>
          {value}
        </a>
      );
    }
    return value;
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={title} data-testid="tenant-info-item-title" />
      <CardContent className={classes.cardContent} data-testid="tenant-info-item-content">
        {renderValue()}
      </CardContent>
    </Card>
  );
};
